import React from 'react'

import PropTypes from 'prop-types'

import projectStyles from '../style.module.css'
import styles from './hero3.module.css'
import { AnimationOnScroll } from 'react-animation-on-scroll';


const Hero3 = (props) => {
  return (
    
    // <div
    //   id="hero"
    //   className={` ${styles['hero']} ${projectStyles['hero']} ${
    //     styles[props.rootClassName]
    //   } `}
    // >
      <div className={styles['container']}>
     
        <div  className={styles['container1']}>    
          <img
            alt="image"
            src="/playground_assets/prosklisi4.png"
            className={styles['image']}
          />
        </div>
     
      </div>
      /* <div className={styles['container2']}>
        <div className={styles['container3']}>
          <img
            alt="image"
            src="/playground_assets/shape4.30d198cefbd4f3328f8f-200w.png"
            className={styles['image1']}
          />
          <img
            alt="image"
            src="/playground_assets/shape3.15680f3d0bbf1b22045c-400w.png"
            className={styles['image2']}
          />
          <div className={styles['container4']}>
            <img
              alt="image"
              src="/playground_assets/232112-800h.jpg"
              className={styles['image3']}
            />
          </div>
        </div>
      </div> */
    //</div>
  )
}

Hero3.defaultProps = {
  rootClassName: '',
}

Hero3.propTypes = {
  rootClassName: PropTypes.string,
}

export default Hero3
